/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiCampaignLeadStatusFromJSON, ApiCampaignLeadStatusToJSON, } from './ApiCampaignLeadStatus';
import { ApiPersonalisationFromJSON, ApiPersonalisationToJSON, } from './ApiPersonalisation';
export function ApiDataPersonalisationFromJSON(json) {
    return ApiDataPersonalisationFromJSONTyped(json, false);
}
export function ApiDataPersonalisationFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'campaignId': !exists(json, 'campaignId') ? undefined : json['campaignId'],
        'componentId': !exists(json, 'componentId') ? undefined : json['componentId'],
        'createdAt': !exists(json, 'createdAt') ? undefined : (new Date(json['createdAt'])),
        'dataId': !exists(json, 'dataId') ? undefined : json['dataId'],
        'firstVisit': !exists(json, 'firstVisit') ? undefined : json['firstVisit'],
        'id': !exists(json, 'id') ? undefined : json['id'],
        'leadId': !exists(json, 'leadId') ? undefined : json['leadId'],
        'personalisation': !exists(json, 'personalisation') ? undefined : ApiPersonalisationFromJSON(json['personalisation']),
        'personalisationId': !exists(json, 'personalisationId') ? undefined : json['personalisationId'],
        'projectId': !exists(json, 'projectId') ? undefined : json['projectId'],
        'referrerLeadId': !exists(json, 'referrerLeadId') ? undefined : json['referrerLeadId'],
        'status': !exists(json, 'status') ? undefined : ApiCampaignLeadStatusFromJSON(json['status']),
        'urlId': !exists(json, 'urlId') ? undefined : json['urlId'],
    };
}
export function ApiDataPersonalisationToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'campaignId': value.campaignId,
        'componentId': value.componentId,
        'createdAt': value.createdAt === undefined ? undefined : (value.createdAt.toISOString()),
        'dataId': value.dataId,
        'firstVisit': value.firstVisit,
        'id': value.id,
        'leadId': value.leadId,
        'personalisation': ApiPersonalisationToJSON(value.personalisation),
        'personalisationId': value.personalisationId,
        'projectId': value.projectId,
        'referrerLeadId': value.referrerLeadId,
        'status': ApiCampaignLeadStatusToJSON(value.status),
        'urlId': value.urlId,
    };
}
